(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-page"]) return;
  try {
    
(function() {
  var form = document.getElementById('contact-form');
  if (!form) return;

  var errBox = document.getElementById('contact-inline-error');
  var MSG = errBox ? errBox.dataset : {};

  function showError(msg) {
    var box = document.getElementById('contact-inline-error');
    var text = document.getElementById('contact-inline-error-text');
    text.textContent = msg;
    box.hidden = false;
    box.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function clearError() {
    document.getElementById('contact-inline-error').hidden = true;
  }

  function validateEmail(val) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val.trim());
  }

  // Fehlerzustand nicht nur faerben, sondern auch ansagen (A11Y-13, 2026-08-29):
  // die Coral-Rahmenfarbe erreicht Screenreader nicht. aria-invalid markiert das
  // Feld, aria-describedby haengt den Text der Inline-Fehlermeldung an — beim
  // Anspringen des Feldes kommt damit die Ursache mit. Beide Attribute werden beim
  // Zuruecksetzen wieder ENTFERNT, sonst bleibt ein korrigiertes Feld «ungueltig».
  var FEHLER_TEXT_ID = 'contact-inline-error-text';
  function markiereFehler(el) {
    if (!el) return;
    el.classList.add('contact-form__input--error');
    el.setAttribute('aria-invalid', 'true');
    el.setAttribute('aria-describedby', FEHLER_TEXT_ID);
  }
  function loescheFehlerMarkierung(el) {
    if (!el) return;
    el.classList.remove('contact-form__input--error');
    el.removeAttribute('aria-invalid');
    el.removeAttribute('aria-describedby');
  }

  // Submit-Listener statt Button-Click: faengt auch die Enter-Taste ab
  // (vorher umging Enter die Validierung via implizitem Submit) und
  // degradiert ohne JS sauber zum nativen Formular-Submit.
  form.addEventListener('submit', function(e) {
    clearError();

    var emailInput = form.querySelector('#contact-email');
    var bodyInput  = form.querySelector('#contact-body');

    var emailVal = emailInput ? emailInput.value.trim() : '';
    var bodyVal  = bodyInput  ? bodyInput.value.trim()  : '';

    // Reset error borders (inkl. aria-invalid/-describedby)
    form.querySelectorAll('.contact-form__input--error').forEach(loescheFehlerMarkierung);

    if (!emailVal) {
      e.preventDefault();
      markiereFehler(emailInput);
      showError(MSG.errEmailRequired);
      return;
    }

    if (!validateEmail(emailVal)) {
      e.preventDefault();
      markiereFehler(emailInput);
      showError(MSG.errEmailInvalid);
      return;
    }

    if (!bodyVal) {
      e.preventDefault();
      markiereFehler(bodyInput);
      showError(MSG.errMessageRequired);
      return;
    }

    // gueltig -> nativer Submit laeuft durch
  });

  // Live: Fehler-Border bei Korrektur entfernen
  ['contact-email', 'contact-body'].forEach(function(id) {
    var el = document.getElementById(id);
    if (!el) return;
    el.addEventListener('input', function() {
      loescheFehlerMarkierung(el);
      clearError();
    });
  });

  // Melde-Vorlage (Knopf «Veranstaltung melden» im Convention-Kalender verlinkt hierher mit
  // ?vorlage=veranstaltung): ein LEERES Nachrichtenfeld bekommt die Vorlage mit den
  // Angaben, die die Pflege-Routine braucht; der Betreff wird vorgewaehlt, das Feld
  // fokussiert, der Cursor steht hinter dem ersten Feld der Vorlage (erste Zeile, die auf
  // Doppelpunkt + Leerzeichen endet: DE «Name der Veranstaltung: », EN «Event name: »),
  // damit man sofort an der ersten Angabe tippt statt am Textende; ohne solche Zeile am
  // Ende (seit 08.10.2026, docs/decisions.md 2026-10-08 (4)). Ein getippter oder nach
  // einem Fehler vom Server zurueckgegebener Text (form.body) bleibt unangetastet. Text aus den Locales
  // (contact.vorlage_veranstaltung, data-Attribut am Feld), gesetzt per value, nie als
  // Markup. Das Feld waechst auf die Zeilenzahl der Vorlage: mit 6 Zeilen scrollte der
  // Cursor am Ende den Anfang der Vorlage aus dem Feld. Submit und Validierung bleiben
  // wie oben. Bewusst kein mailto-Link: ohne eingerichteten Mailclient passiert beim
  // Klick nichts (oder ein fremdes Programm startet), und die Meldung verliesse den
  // Shopify-Kontaktfluss (Eingang im Admin, Spam-Schutz, Antwort aus dem Shop-Postfach).
  (function vorlageEinsetzen() {
    const vorlageName = new URLSearchParams(window.location.search).get('vorlage');
    if (vorlageName !== 'veranstaltung') return;
    const feld = document.getElementById('contact-body');
    if (!feld || feld.value.trim() !== '') return;
    const vorlage = feld.dataset.vorlageVeranstaltung;
    if (!vorlage) return;
    feld.value = vorlage;
    feld.rows = Math.max(feld.rows, vorlage.split('\n').length);
    const betreff = document.getElementById('contact-subject');
    if (betreff && betreff.value === '' && betreff.querySelector('option[value="Veranstaltung"]')) {
      betreff.value = 'Veranstaltung';
    }
    feld.focus();
    let cursor = feld.value.length;
    let zeilenStart = 0;
    for (const zeile of feld.value.split('\n')) {
      if (zeile.endsWith(': ')) {
        cursor = zeilenStart + zeile.length;
        break;
      }
      zeilenStart += zeile.length + 1;
    }
    feld.setSelectionRange(cursor, cursor);
  })();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pokemon-kartenliste-uebersicht"]) return;
  try {
    
/* Set-Suche der Uebersicht: statisches DOM-Filtern ueber die Kacheln, leere
   Serien-Gruppen fallen mit. Kein uebersetzter String noetig — dieser Block
   wird als statisches Asset ausgeliefert und NICHT durch Liquid gerendert.

   Anhang-Zeilen (Galerie-Sets) haben eigene Suchtexte, aber keine eigene
   Sichtbarkeit: eine Kachel bleibt stehen, sobald ihr eigener Text ODER der
   Text einer ihrer Anhang-Zeilen passt — und die Anhang-Zeilen laufen immer
   mit ihrer Kachel mit. So findet die Suche "Galar-Galerie" und "CRZ:GG",
   ohne dass eine Zeile ohne ihren Kontext dasteht. */
(function () {
  var root = document.querySelector('[data-pkidx]');
  if (!root) return;

  var feld = root.querySelector('.pkidx__search');
  if (!feld) return;

  var serien = Array.prototype.slice.call(root.querySelectorAll('.pkidx__serie'));
  var leer = root.querySelector('[data-pkidx-noresults]');
  var zaehler = root.querySelector('[data-pkidx-count]');
  var vorlage = root.dataset.tplCount || '';

  /* Lupe-Button: springt mit der aktuellen Eingabe als #q= auf die
     Kartensuche (Fragment statt Query seit 2026-10-04, Audit SEO-025: Shopify
     kanonisierte ?q=-Varianten mit, das Fragment erreicht den Server nie;
     kartensuche.js liest #q= und weiterhin ?q= fuer alte Links); gleiche
     Wirkung hat Enter im Feld. Ohne data-url (Suchseite nicht angelegt)
     bleibt die Lupe dekorativ. */
  var lupeBtn = root.querySelector('[data-pkidx-cardsearch]');
  var suchseiteUrl = lupeBtn ? (lupeBtn.dataset.url || '') : '';
  function zurKartensuche() {
    if (!suchseiteUrl) return;
    var q = feld.value.trim();
    window.location.href = q === ''
      ? suchseiteUrl
      : suchseiteUrl + '#q=' + encodeURIComponent(q);
  }

  var eintraege = Array.prototype.map.call(
    root.querySelectorAll('.pkidx__cell'),
    function (zelle) {
      var texte = [zelle.dataset.s || ''];
      Array.prototype.forEach.call(
        zelle.querySelectorAll('[data-pkidx-sub]'),
        function (zeile) { texte.push(zeile.dataset.s || ''); }
      );
      var serie = zelle.closest('.pkidx__serie');
      return { el: zelle, texte: texte, serieId: serie ? serie.id : '' };
    }
  );

  /* Serien-Filter (Pillen): Klick collapst auf eine Serie, erneuter Klick loest.
     Kombiniert sich mit der Textsuche — beide Bedingungen muessen passen. */
  var serieFilter = '';
  var pillen = Array.prototype.slice.call(root.querySelectorAll('.pkidx__jump-link'));

  function anwenden() {
    var q = feld.value.trim().toLowerCase();
    var treffer = 0;

    eintraege.forEach(function (eintrag) {
      var passtText = q === '' || eintrag.texte.some(function (text) {
        return text.indexOf(q) !== -1;
      });
      var passtSerie = serieFilter === '' || eintrag.serieId === serieFilter;
      var sichtbar = passtText && passtSerie;
      eintrag.el.hidden = !sichtbar;
      if (sichtbar) treffer++;
    });

    serien.forEach(function (serie) {
      serie.hidden = !serie.querySelector('.pkidx__cell:not([hidden])');
    });

    if (leer) leer.hidden = treffer !== 0;
    if (zaehler) {
      zaehler.textContent = (q === '' && serieFilter === '')
        ? ''
        : vorlage.replace('__N__', treffer).replace('__TOTAL__', eintraege.length);
    }
  }

  pillen.forEach(function (pille) {
    pille.addEventListener('click', function () {
      serieFilter = serieFilter === pille.dataset.serie ? '' : pille.dataset.serie;
      pillen.forEach(function (p) {
        var aktiv = serieFilter !== '' && p.dataset.serie === serieFilter;
        p.classList.toggle('pkidx__jump-link--active', aktiv);
        p.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      });
      anwenden();
    });
  });

  if (lupeBtn) lupeBtn.addEventListener('click', zurKartensuche);

  feld.addEventListener('input', anwenden);
  feld.addEventListener('keydown', function (ev) {
    if (ev.key === 'Enter') {
      ev.preventDefault();
      zurKartensuche();
      return;
    }
    if (ev.key === 'Escape' && feld.value !== '') {
      feld.value = '';
      anwenden();
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pokemon-set-kartenliste"]) return;
  try {
    
/* Kartenliste filtern: rein statisches DOM-Filtern ueber max. ~300 Zeilen —
   kein Framework, kein Fetch. Uebersetzte Texte kommen ueber data-Attribute,
   weil dieser Block als statisches Asset ausgeliefert und NICHT durch Liquid
   gerendert wird. */
(function () {
  var root = document.querySelector('[data-pkset]');
  if (!root) return;

  var zeilen = Array.prototype.slice.call(root.querySelectorAll('.pkset__row'));
  if (!zeilen.length) return;

  var feld = root.querySelector('.pkset__search');
  var chips = Array.prototype.slice.call(root.querySelectorAll('.pkset__chip'));
  var gruppen = Array.prototype.slice.call(root.querySelectorAll('.pkset__group'));
  var zaehler = root.querySelector('[data-pkset-count]');
  var leer = root.querySelector('[data-pkset-noresults]');
  var vorlage = root.dataset.tplCount || '';
  var gesamt = zeilen.length;
  var aktiveRarity = '';

  function anwenden() {
    var q = feld ? feld.value.trim().toLowerCase() : '';
    var treffer = 0;

    zeilen.forEach(function (zeile) {
      var passtText = q === '' || zeile.dataset.s.indexOf(q) !== -1;
      var passtRarity = aktiveRarity === '' || zeile.dataset.r === aktiveRarity;
      var sichtbar = passtText && passtRarity;
      zeile.hidden = !sichtbar;
      if (sichtbar) treffer++;
    });

    gruppen.forEach(function (gruppe) {
      gruppe.hidden = !gruppe.querySelector('.pkset__row:not([hidden])');
    });

    if (leer) leer.hidden = treffer !== 0;
    if (zaehler) {
      zaehler.textContent = (q === '' && aktiveRarity === '')
        ? ''
        : vorlage.replace('__N__', treffer).replace('__TOTAL__', gesamt);
    }
  }

  if (feld) {
    feld.addEventListener('input', anwenden);
    feld.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && feld.value !== '') {
        feld.value = '';
        anwenden();
      }
    });
  }

  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      aktiveRarity = chip.dataset.rarity || '';
      chips.forEach(function (c) {
        var aktiv = c === chip;
        c.classList.toggle('pkset__chip--active', aktiv);
        c.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      });
      anwenden();
    });
  });
})();

/* Illustratoren-Zeile: auf 2 Zeilen zuklappen, Toggle nur bei echtem
   Ueberlauf (Muster «Preview-Kappung», docs/patterns.md). Grosse Listen
   kommen seit 2026-08-29 bereits gekappt aus dem Server-HTML (PERF-8,
   Schwelle im Liquid) — hier wird nur noch nachgemessen und die Kappung
   wieder GELOEST, wenn gar kein Ueberlauf vorliegt (kein toter Knopf). */
(function () {
  var wrap = document.querySelector('[data-pkset-illus]');
  if (!wrap) return;
  var liste = wrap.querySelector('[data-pkset-illus-list]');
  var knopf = wrap.querySelector('[data-pkset-illus-toggle]');
  if (!liste || !knopf) return;

  /* inert folgt dem sichtbaren Zustand (A11Y-4): zugeklappt liegen bis zu
     ~100 Links unsichtbar, aber tabbar in der Klammer — der Fokus scrollte
     sie beim Durchtabben dauerhaft weg (gemessen scrollTop 211). Beim
     Zuklappen zusaetzlich zurueckscrollen, sonst bleibt der weggescrollte
     Ausschnitt als sichtbarer Rest stehen. */
  function inertSetzen(zu) {
    if (zu) { liste.setAttribute('inert', ''); liste.scrollTop = 0; }
    else liste.removeAttribute('inert');
  }

  wrap.classList.add('pkset__illus--collapsed');
  inertSetzen(true);
  /* 2px-Toleranz gegen Subpixel-Rundung (gleiche Schwelle wie die
     Beschreibungs-Kappung der Produktseite). */
  if (liste.scrollHeight - liste.clientHeight < 2) {
    wrap.classList.remove('pkset__illus--collapsed');
    inertSetzen(false);
    return;
  }

  knopf.hidden = false;
  knopf.addEventListener('click', function () {
    var zu = wrap.classList.toggle('pkset__illus--collapsed');
    inertSetzen(zu);
    knopf.textContent = zu ? knopf.dataset.more : knopf.dataset.less;
    knopf.setAttribute('aria-expanded', zu ? 'false' : 'true');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sammler-kalender"] && !Shopify.designMode) return;
  try {
    
/* «in N Tagen» der Terminkarten nach Europe/Zurich nachrechnen: das HTML liegt im CDN-Cache
   und kennt «heute» nur vom Render (docs/patterns.md «Zeitabhaengige Anzeige»). Rechnung und
   Textwahl sind hdk.abstandText (assets/hdk-util.js, unit-getestet), dieselbe Funktion wie im
   Hero des Convention-Kalenders. Das gebuendelte Skript kann vor hdk-util.js stehen (beide
   defer): darum ohne window.hdk bis DOMContentLoaded warten. */
(function () {
  function nachrechnen() {
    if (!window.hdk) return;
    const jetzt = new Date();
    document.querySelectorAll('[data-sk-countdown]').forEach(function (el) {
      const text = window.hdk.abstandText(el.dataset, jetzt);
      if (text && el.textContent !== text) el.textContent = text;
    });
  }
  if (window.hdk) nachrechnen();
  else document.addEventListener('DOMContentLoaded', nachrechnen);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tcg-release-calendar"]) return;
  try {
    
(function () {
  var chips = document.querySelectorAll('.tcgrel__chip');
  if (!chips.length) return;

  // Franchise-Filter: blendet Zeilen und leere Monats-Gruppen der Liste aus
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      var aktiveFranchise = chip.dataset.franchise || '';
      chips.forEach(function (c) {
        var aktiv = c === chip;
        c.classList.toggle('tcgrel__chip--active', aktiv);
        c.setAttribute('aria-pressed', aktiv ? 'true' : 'false');
      });
      document.querySelectorAll('.tcgrel__row').forEach(function (row) {
        row.hidden = aktiveFranchise !== '' && row.dataset.franchise !== aktiveFranchise;
      });
      document.querySelectorAll('.tcgrel__entries').forEach(function (ul) {
        var leer = !ul.querySelector('.tcgrel__row:not([hidden])');
        ul.hidden = leer;
        var h = ul.previousElementSibling;
        if (h && h.classList.contains('tcgrel__month')) h.hidden = leer;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
